import React from "react";

import { Skeleton } from "antd";
import InsightsError from "./InsightsError";
import useRunIndividual from "../../../hooks/insights/useRunIndividual";
import RingProgressChartInsights from "../../Charts/RingProgressChartInsights";
import { formatNumber } from "../../../utils/MainHelper";

function InsightsDetails({
    data, position = "right", withTitle = false, customDetails, language
}) {
    const score = formatNumber(data.score * 100, 2);

    let tempDetails = useRunIndividual(data, language);
    if (customDetails) {
        tempDetails = customDetails
    }
    const {
        isLoading, details, isError, setRerun
    } = tempDetails

    const getContent = () => {
        if (isLoading) return null;
        return details;
    };
    return (
        <div className="report--insights--details">
            {isError
                ? <InsightsError show={isError} setRerun={setRerun} />
                : (
                    <>
                        {withTitle && (
                            <div className="report--insights--details--header">
                                <span className="report--insights--details--title">{data.categoryName}</span>
                                <span className="report--insights--details--subtitle with-bottom-border">{data.item}</span>
                            </div>
                        )}
                        <p className={`report--insights--details--paragraph ${position}${isLoading ? " flexrow" : ""}`}>
                            {isLoading
                                ? <Skeleton paragraph={{ rows: 6 }} active />
                                : <>
                                    <div className={`report--insights--details--ringcont ${position}`}>
                                        <RingProgressChartInsights
                                            middleTitle={`${score}%`}
                                            color={data.color}
                                            subColor={data.bg}
                                            percent={data.score}
                                            behaviormatch={data.behaviormatch}
                                        />
                                    </div>
                                    {getContent()}
                                </>}
                        </p>
                    </>
                )}
        </div>
    );
}

export default InsightsDetails;
